module.exports = {
    contentUri: 'https://pre.lionsgateplay.com',
    apiUri: 'https://lgi-dev-api.aws.playco.com/api/v1.0/',
    allowedDomains: [
        'starzplayarabia.com',
        '.playco.com',
        'starzplay.local',
        '.test',
        '.najam',
        '.starz',
        'pre.lionsgateplay.com',
        'lionsgateplay.com'
    ],
    sessionStorageKey: 'SPConf',
    googleAnalyticsId: 'UA-172712536-1'
};



// WEBPACK FOOTER //
// ./src/config/test.js